import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { TokenService } from 'src/app/services/authentication/parameters';
import { CommunicationSecurityService } from 'src/app/services/communication';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LogoutService {
  private baseUrl: string;
  constructor(private tokenService: TokenService, private communicationSecurityService: CommunicationSecurityService) {
    this.baseUrl = `${environment.securityBasePath}`;
  }

  public logoutSession(): Observable<any> {
    const { refreshToken, userId } = this.tokenService.get();
    const url = `${this.baseUrl}/Account/Logout`;
    return this.communicationSecurityService.post(url, { refreshToken, userId }).pipe(catchError((err) => throwError(() => err.error)));
  }
}
